import React, { FC, useState } from "react"
import { useDispatch } from "react-redux"
import { CenteredLoadingIndicator } from "../../../molecules/Molecules"
import { FlexRowCenter, Spacer } from "../../../atoms/Atoms"
import { fetchReimbursementDetails } from "../../../../../actions/reimbursementDetailsActions"
import CarrotClient from "carrot-api"
import Settings from "../../../../../utils/CarrotConfig"
import { Steps } from "../Workflow/Steps"
import useInitialSetup from "../hooks/useInitialSetup"
import { useProgressTracker } from "../../ProgressTracker"
import { useStateMachine } from "../../../../context/stateMachine/StateMachineContext"
import { H2 } from "@carrotfertility/carotene"

const ViewName = Steps.PROCESS_CONNECT_INSURANCE
const ProcessConnectInsuranceView: FC = () => {
  const { setProgress } = useProgressTracker()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const { setNextStep } = useStateMachine(ViewName, null)

  useInitialSetup(() =>
    dispatch(async (dispatch) => {
      const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
      const success = await client.verifyMemberInsurance()
      dispatch(fetchReimbursementDetails())
      setLoading(false)
      setNextStep(Steps.PROCESS_CONNECT_INSURANCE, success)
    })
  )
  setProgress(2, "CONNECT YOUR INSURANCE")

  return (
    <>
      <Spacer height={2} />
      {loading && <CenteredLoadingIndicator />}
      <FlexRowCenter>
        <H2 variant="dark">{"We're working on your request."}</H2>
      </FlexRowCenter>
      <Spacer height={4} />
    </>
  )
}

export { ProcessConnectInsuranceView }
